
function Spinner() {
  return (
    <div className="spinner-border SpinnerBox" role="status">
      <span className="sr-only"></span>
    </div>
  );
}

export default Spinner;